

  <h1 class="main-title neutral-1-color">{{ title }}</h1>
  <div class="document-list list-documents">
    <div class="row">

      <div *ngFor="let item of data" class="col-12 col-md-4 col-lg-3 item p-2 p-md-3">
        <div class="card-wrapper document-card">
          <div class="card">
            <div class="card-body">
              <a [routerLink]="item?.link" class="">
                <h5 class="card-title">{{ item.title }}</h5>
              </a>
              <p class="card-text">
                {{ item.content }}
              </p>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
